export { default } from './LoyaltyCommission';